import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  error: undefined,
  selectable: false,
  selectedRowKeys: [],
  selectedRows: [],
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.cuenta.sucursal.list.busy = true;
    state.cuenta.sucursal.list.filters = {
      ...state.cuenta.sucursal.list.filters,
      ...meta,
    };
  });

  try {
    const { filters, pagination } = store.state.cuenta.sucursal.list;

    const params = {
      limit: meta.limit || pagination.limit,
      page: meta.page || filters.page,
      ...meta,
    };

    const response = await Http.get('api/catalogos/sucursal', { params });

    store.setState((state) => {
      state.cuenta.sucursal.list.busy = false;
      state.cuenta.sucursal.list.data = response.data;
      state.cuenta.sucursal.list.pagination = {
        ...state.cuenta.sucursal.list.pagination,
        ...response.meta?.pagination,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.sucursal.list.error = error.data || error;
      state.cuenta.sucursal.list.busy = false;
    });
  }
};

const remove = async (store, meta, id) => {
  store.setState((state) => {
    state.cuenta.sucursal.list.busy = true;
    state.cuenta.sucursal.list.error = undefined;
    state.cuenta.sucursal.list.result = undefined;
  });

  try {
    const response = await Http.delete(`api/catalogos/sucursal/${id}`);

    store.setState((state) => {
      state.cuenta.sucursal.list.busy = false;
      state.cuenta.sucursal.list.data = response.data;
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.sucursal.list.error = error.data || error;
      state.cuenta.sucursal.list.busy = false;
    });
  }
};

const resetError = (store) => (state) => {
  state.cuenta.sucursal.list.error = undefined;
};

const setSelectable = (store, selectable) => (state) => {
  state.cuenta.sucursal.list.selectable = selectable;
};

const setSelection = (store, selectedRows, selectedRowKeys) => {
  return (state) => {
    state.cuenta.sucursal.list = {
      ...state.cuenta.sucursal.list,
      selectedRows: selectedRows,
      selectedRowKeys: selectedRowKeys,
    };
  };
};

const clearSelection = () => {
  return (state) => {
    state.cuenta.sucursal.list = {
      ...state.cuenta.sucursal.list,
      selectable: false,
      selectedRowKeys: [],
      selectedRows: [],
    };
  };
};

const highlight = (store, metadata) => {
  store.setState((state) => {
    state.cuenta.sucursal.list.data = metadata;
  });
};

const actions = {
  paginate,
  resetError,
  remove,
  setSelectable,
  setSelection,
  clearSelection,
  highlight,
};

const SucursalListStore = {
  state: () => initialState,
  actions,
};

export default SucursalListStore;
